const sizes = [ 'S', 'M', 'L', 'XL', 'XXL'];

export const validShirtEN = (data) => sizes.includes(data);
